import React from 'react'
import Counter from '../general/Counter';
import AboutImg from '../assets/about-img.jpg';
import SubHeader from '../general/SubHeader';

const About = () => {
    return (
        <>

            <SubHeader message="About Us" />
            {/* About section */}
            <section className='my-5'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-lg-6 col-12 my-2'>
                            <img src={AboutImg} className='img-fluid rounded' alt='About Anvi foundation' />
                        </div>

                        <div className='col-lg-6 col-12 mt-4 order-first order-lg-last'>
                            <p className='sec-heading'>Anvi Foundation</p>
                            <hr className='sec-heading-hr my-auto' />

                            <p className='text-muted mt-4'>The Anvi Foundation is a non-profit organization dedicated to promoting sustainable development and social welfare. Through a variety of initiatives, the foundation focuses on areas such as education, healthcare, environmental conservation, and empowerment of marginalized communities.</p>
                            <p className='text-muted'>By providing resources, support, and awareness, Anvi Foundation strives to create a positive impact on society and help build a better future for those in need. Its mission is to drive social change through collaborative efforts and sustainable practices that uplift individuals and communities.</p>
                            <p className='text-muted'>By providing resources, support, and awareness, Anvi Foundation strives to create a positive impact on society and help build a better future for those in need. Its mission is to drive social change through collaborative efforts and sustainable practices that uplift individuals and communities.</p>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* About section ends */}

            <Counter />


            {/* History Section */}
            <section className='my-5'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-lg-6 col-12 my-2'>
                            <div className='donation-card h-auto px-4 py-4'>
                            <i className="fs-1 fas fa-history"></i>

                                <p className='sec-heading5 my-3'>Our History</p>
                                <hr />
                                <p className='text-muted'>The Anvi Foundation is a non-profit organization dedicated to promoting sustainable development and social welfare. Through a variety of initiatives, the foundation focuses on areas such as education, healthcare, environmental conservation, and empowerment of marginalized communities.</p>
                                <p className='text-muted'>The Anvi Foundation is a non-profit organization dedicated to promoting sustainable development and social welfare. Through a variety of initiatives, the foundation focuses on areas such as education, healthcare, environmental conservation, and empowerment of marginalized communities.</p>
                            </div>
                        </div>

                        <div className='col-lg-6 col-12 my-2'>
                            <div className='donation-card h-auto px-4 py-4'>
                            <i className="fs-1 fa-solid fa-bullseye"></i>

                                <p className='sec-heading5 my-3'>Our Mission</p>
                                <hr />
                                <p className='text-muted'>The Anvi Foundation is a non-profit organization dedicated to promoting sustainable development and social welfare. Through a variety of initiatives, the foundation focuses on areas such as education, healthcare, environmental conservation, and empowerment of marginalized communities.</p>
                                <p className='text-muted'>The Anvi Foundation is a non-profit organization dedicated to promoting sustainable development and social welfare. Through a variety of initiatives, the foundation focuses on areas such as education, healthcare, environmental conservation, and empowerment of marginalized communities.</p>
                            </div>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* History Section ends */}

        </>
    )
}

export default About
